// extracted by mini-css-extract-plugin
export default {"ul":"ProfileOrdersPage_ul__wxULq","li":"ProfileOrdersPage_li__yS97X"};